export function parseDollarAmt(amt) {
  if (amt < 100) {
    return "0";
  }
  return Math.floor(amt / 100);
}
